import { initCatalogFx } from 'domains/application';
import { changeRestaurant, getDeliveryZoneFx } from 'domains/cartography';
import { sample } from 'effector';
import { getLegalsDocumentsFx } from './effects';
import { $legalsDocuments } from './stores';

sample({
  clock: getLegalsDocumentsFx.doneData,
  fn: (response) => response,
  target: $legalsDocuments,
});

sample({
  clock: initCatalogFx.doneData,
  filter: ({ deliveryZone, currentRestaurant, currentCity }) =>
    !!deliveryZone || !!currentRestaurant || !!currentCity,
  fn: ({ deliveryZone, currentRestaurant, currentCity }) => {   
    let placeId: string;
    if (deliveryZone) placeId = deliveryZone.id;
    else if (currentRestaurant) {placeId = currentRestaurant!.id;} 
    else placeId = currentCity.defaultRestaurantId
    return { placeId };
  },
  target: getLegalsDocumentsFx,
});

sample({
  clock: changeRestaurant,
  filter: (restaurant) => !!restaurant,
  fn: (restaurant) => ({ placeId: restaurant!.id }),
  target: getLegalsDocumentsFx,
});
sample({
  clock: getDeliveryZoneFx.doneData,
  fn: ({ deliveryZone }) => ({ placeId: deliveryZone.id }),
  target: getLegalsDocumentsFx,
});
